import React, { useLayoutEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function ScrollStack({ cards = [], renderCard, className = '' }) {
  const sectionRef = useRef(null);
  const rowRefs = useRef([]);
  const cardRefs = useRef([]);

  useLayoutEffect(() => {
    rowRefs.current = rowRefs.current.slice(0, cards.length);
    cardRefs.current = cardRefs.current.slice(0, cards.length);
    const mm = gsap.matchMedia();

    mm.add('(prefers-reduced-motion: no-preference)', () => {
      const allCards = cardRefs.current.filter(Boolean);
      const rows = rowRefs.current.filter(Boolean);

      allCards.forEach((card, index) => {
        gsap.set(card, { autoAlpha: 1, scale: index === 0 ? 1 : 1.1, transformOrigin: 'center center' });
      });

      allCards.slice(0, -1).forEach((card, index) => {
        const nextRow = rows[index + 1];
        const nextCard = allCards[index + 1];
        if (!nextRow || !nextCard) return;

        gsap.timeline({
          scrollTrigger: {
            trigger: nextRow,
            start: 'top bottom+=20%',
            end: 'top top-=28%',
            scrub: true,
            invalidateOnRefresh: true,
          },
        }).to(nextCard, { scale: 1, ease: 'none' }, 0);

        gsap.to(card, {
          scale: 0.9,
          ease: 'none',
          scrollTrigger: {
            trigger: nextRow,
            start: 'top bottom',
            end: 'top top+=14%',
            scrub: true,
            invalidateOnRefresh: true,
          },
        });

        gsap.to(card, {
          autoAlpha: 0,
          ease: 'none',
          scrollTrigger: {
            trigger: nextRow,
            start: 'top top+=14%',
            end: 'top top+=2%',
            scrub: true,
            invalidateOnRefresh: true,
          },
        });
      });
    }, sectionRef);

    return () => mm.revert();
  }, [cards]);

  return (
    <div ref={sectionRef} className={`ob-stack ${className}`}>
      {cards.map((item, index) => (
        <div key={item.id ?? index} ref={(el) => { rowRefs.current[index] = el; }} className="ob-stack__row">
          <div className="ob-stack__sticky" style={{ zIndex: index + 1 }}>
            <div
              ref={(el) => { cardRefs.current[index] = el; }}
              className="ob-stack__card"
              style={{ background: item.bg, color: item.fg }}
            >
              {renderCard(item, index)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
